<template>
  <div>
    <common-dialog
      ref="dialog"
      width="400px"
      show-save-button
      unit="入口成绩计算设置"
      id-key="OtherId"
      :data="data"
      form-label-width="90px"
      :before-save="onBeforeSave"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:16">
            <el-form-item label="考试次数" prop="times">
              <el-input v-model="times" type="number" @blur="checkNum" placeholder="请填写考试次数"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="各次数占比">
              <el-table :data="tableData" style="max-width:100%" size="small" border>
                <el-table-column type="index" label="考试次数" width="90" align="center" />
                <el-table-column prop="ExamRatio" label="各次数占比/%" align="center">
                  <template slot-scope="{row}">
                    <el-input v-model="row.ExamRatio" type="number" size="mini"></el-input>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import api from "@/api/achieve/params/entry";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        ConfigEntryId: 0,
        ExamNumber: 0,
        ExamRatio: "",
      },
      tableData: [],
      times: 1,
      api,
      rules: {
        // times: [{ required: true, message: "请填写考试次数" }],
      },
      isMB: this.$store.state.isMB
    };
  },
  computed: {},
  methods: {
    onEditOpened(row) {
      this.times = row.ExamNumber;
      let arr = row.ExamRatio.split("%")
      let result = []
      arr.forEach((e,index) => {
        if(index < arr.length-1) {
          result.push(e.split(": ")[1])
        }
      })
      for (let i = 0; i < row.ExamNumber; i++) {
        this.tableData.push({
          ExamRatio: result[i]
        })
      }
    },
    onCreateOpened() {
      this.add();
    },
    checkNum() {
      if(!(this.times>0)) {
        this.times = 1;
      } else if(this.times %1 != 0) {
        this.times = Math.floor(this.times);
      }
      while (this.times>this.tableData.length) {
        this.add()
      }
      if(this.times<this.tableData.length) {
        this.tableData = this.tableData.slice(0,this.times)
      }
    },
    add() {
      this.tableData.push({
        ExamRatio: "",
      })
    },
    onBeforeSave() {
      // if(this.data.OtherValue === null) {
      //   this.$message.error(this.data.OtherType + "不能为空")
      //   return false
      // }
      // if(this.data.SerialNumber < 0) {
      //   this.$message.error("请填写正确的序号")
      //   return false
      // } else {
      //   this.data.SerialNumber = Math.floor(this.data.SerialNumber)
      // }
      if(!(this.times>0&&this.times%1==0)) {
        this.$message.error("考试次数须为正整数")
        return false
      }
      let td = this.tableData;
      let total = 0;
      this.data.ExamRatio = "";
      for (let i = 0; i < td.length; i++) {
        if(!(Number(td[i].ExamRatio)>0)) {
          this.$message.error("各次数占比须大于0")
          return false
        }
        total += Number(td[i].ExamRatio)
        this.data.ExamRatio = this.data.ExamRatio + (i+1 + ': ' + td[i].ExamRatio + '% ; ');
      }
      if(total != 100) {
        this.$message.error("各次数占比总和须等于100")
        return false;
      }
      this.data.ExamNumber = this.times;
      return true
    },
    onClosed() {
      this.tableData = [];
      this.times = 1;
    }
  },
};
</script>
<style lang="scss">
</style>